import React from 'react';
import ProgramsSection from '../../components/ProgramsSection';
import CTASection from '../../components/CTASection';
import SEO from '../components/SEO';
import ErrorBoundary from '../components/ErrorBoundary';
const ProgramsPage = () => {
  // Structured data for services
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Legacy Lab Financial Programs',
    description: 'Financial programs designed to help entrepreneurs, investors, and empire-builders multiply their income, influence, and legacy.',
    provider: {
      '@type': 'Organization',
      name: 'Legacy Lab Financial'
    },
    serviceType: 'Financial Coaching',
    offers: [{
      '@type': 'Offer',
      name: 'Wealth Discovery Accelerator',
      description: 'Best for new investors or professionals with limited capital ready to grow',
      price: '1000',
      priceCurrency: 'USD'
    }, {
      '@type': 'Offer',
      name: 'Wealth Builder Blueprint',
      description: 'Best for entrepreneurs & investors with cashflow looking to build estate & legacy',
      price: '2500',
      priceCurrency: 'USD'
    }, {
      '@type': 'Offer',
      name: 'Wealth Legacy Accelerator',
      description: 'Best for serious wealth builders ready to acquire profitable businesses/assets',
      price: '5000',
      priceCurrency: 'USD'
    }]
  };
  return <>

      <ErrorBoundary data-id="element-428">
        <ProgramsSection data-id="element-429" />
      </ErrorBoundary>
      <ErrorBoundary data-id="element-430">
        <CTASection data-id="element-431" />
      </ErrorBoundary>
    </>;
};
export default ProgramsPage;